import { makeStyles } from "@material-ui/core";

export default makeStyles((_theme) => ({
	pricePreviewTable: {
		border: "solid 1px #cddcdc",
		borderRadius: "4px",
		backgroundColor: "#f5f8f9",
		"& th, & td": {
			padding: "8px 24px",
		},
	},
	relatedCasesTable: {
		backgroundColor: "#f5f8f9",
		borderCollapse: "collapse",
		overflowX: "auto",
		"& td": {
			padding: "8px 24px",
		},
		"& th": {
			position: "sticky",
			top: 0,
			zIndex: 7,
			fontSize: "14px",
			padding: "8px 24px",
			backgroundColor: "#f5f8f9",
		},
	},
	tableBox: {
		maxHeight: 180,
		border: "solid 1px #cddcdc",
		borderRadius: "4px",
		overflow: "auto",
		padding: 0,
	},
}));
